import { Component } from '@angular/core';

@Component({
  selector: 'ui-list-inner',
  templateUrl: './list-inner.component.html'
})
export class ListInnerComponent {
}